import React from 'react'

import { DRIFT_CHAT_CONVERSATIONS_RATINGS_MEASURES } from 'cube/constants'
import { isNil } from 'ramda'

import { Link, Text } from '@driftt/dds'
import { CubeQueryStringAdapter } from '@driftt/dds.reports'

import { useTrackDrillDownClickEvent } from 'components/conversation/hooks/useTrackDrilldownClickEvent'
import { ReportKPICard } from 'components/KPICard'
import useRoutingReportDrillDownQuery from 'components/routing/RoutingReportDrillDown/hooks/useRoutingReportDrillDownQuery.hook'
import { CONVO_DETAIL_REPORT_PATH } from 'layouts/ConversationsDetailReport/ConversationsDetailReport.constants'
import { TypeFormats } from 'utils/format'

import { CSAT_RANGE_DESCRIPTION } from './AverageCSAT.constants'
import useAverageCSAT from './useAverageCSAT.hook'

export const AverageCSAT = () => {
  const {
    score,
    metric,
    isLoading,
    isError,
    hasNoData,
    totalRecords,
    totalRequests,
  } = useAverageCSAT()
  const { drillDownCubeQuery } = useRoutingReportDrillDownQuery(
    DRIFT_CHAT_CONVERSATIONS_RATINGS_MEASURES.RATING_AVERAGE
  )

  const { trackViewEvent } = useTrackDrillDownClickEvent(
    'RoutingDeadEndChatsKPICard'
  )

  const drillDownQueryString =
    CubeQueryStringAdapter.toQueryString(drillDownCubeQuery)

  return (
    <ReportKPICard
      isLoading={isLoading}
      isError={isError}
      hasNoData={hasNoData}
      title="CSAT score"
      subtitle="What was the average rating given to teammates who were routed into a conversation?"
      score={score}
      metric={metric}
      metricRange={CSAT_RANGE_DESCRIPTION}
      formatMetric={(csat: number) => TypeFormats.ONE_DECIMAL(csat)}
    >
      {!isNil(totalRequests) && !isNil(totalRecords) && (
        <Text variant="metadata">
          {totalRecords.toLocaleString()} out of{' '}
          {totalRequests.toLocaleString()} routed chats
        </Text>
      )}
      {!!totalRecords && (
        <Link
          target="_blank"
          variant="inline"
          href={`${CONVO_DETAIL_REPORT_PATH}?${drillDownQueryString}`}
          onClick={() => trackViewEvent({ totalRecords: metric ?? 0 })}
        >
          View data
        </Link>
      )}
    </ReportKPICard>
  )
}
